export default {"src":"/_next/static/media/TrueOrFalse.142af977.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};